import { ReactNode } from 'react';
import styled from 'styled-components';

// Default no gap components
const List = styled.ul<{ $gap: string }>`
	& > *:not(:last-child) {
		padding-bottom: ${({ $gap }) => $gap};
	}
	color: inherit;
	border-color: inherit;
`;

const ListItem = styled.li<{ $showBullet: boolean }>`
	position: relative;
	${({ $showBullet }) => $showBullet && 'padding-left: 12px;'}
	color: inherit;
	border-color: inherit;
`;

const ConnectionBorder = styled.div`
	position: absolute;
	left: 3px;
	top: 12px; // Size plus position of bullet
	border-right: 1px solid;
	border-color: inherit;
	height: calc(100% - 7px); // 100% minus start position of bullet
`;

const Bullet = styled.span`
	position: absolute;
	left: 0;
	z-index: 1;
	margin-top: 5px;
	height: 7px;
	width: 7px;
	border-radius: 50%;

	border: 1px solid;
	border-color: inherit;
`;

/**
 * List with bullet points and connection border between items
 * Note: Positions bullet points relative to <Small> typography
 *
 * @param gap - Space between items
 *
 * @example
 * <BetRecommendationsBulletConnectedList gap="12px">
 * 	<BetRecommendationsBulletConnectedListItem><Small>Item 1</Small></BetRecommendationsBulletConnectedListItem>
 * </BetRecommendationsBulletConnectedList>
 */
export const BetRecommendationsBulletConnectedList: React.FC<{ gap?: string; children: ReactNode }> = ({
	gap = '0',
	children
}) => <List $gap={gap}>{children}</List>;

export const BetRecommendationsBulletConnectedListItem: React.FC<{
	children: ReactNode;
	isLast: boolean;
	showBullet?: boolean;
}> = ({ children, showBullet = true, isLast }) => (
	<ListItem $showBullet={showBullet}>
		{showBullet && <Bullet />}
		{showBullet && !isLast && <ConnectionBorder />}
		{children}
	</ListItem>
);
